import React, { Reducer, useReducer } from 'react'
import { Action, KeyValuePayload } from '../../model'
import { IProviderProps, ISetModal, IStateActions, IVisibilityState } from './types'

const VisibilityContext = React.createContext({} as IProviderProps)

const VisibilityReducer = (state: any, action: Action<KeyValuePayload>) => {
    switch(action.type){
        case "set-visibility": 
            return { ...state, [action.payload.key]: action.payload.value }
        case "logout": 
            return {}
    }
}

export const VisibilityProvider = (props: any) => {
    const [state, dispatch] = useReducer<Reducer<IVisibilityState, Action<KeyValuePayload>>>(VisibilityReducer, {
        isLoading: false,
        notification: {status: false, message: '', title: '', type: 'success'},
        isOnline: true,
        showViewResults: false,
        showLogout: false,
        isModal: false,
        showUserProfileModal: false,
        showCommentModal: false,
        deleteResultModal: false,
        broadCastMail: false,
        resetPassword: false,
        showAddUserModal: false,
        showEditUserModal:false
    }) 

    async function loader (value: boolean) {
        await dispatch({type: "set-visibility", payload: {key: 'isLoading', value }})
    }

    const notifier = {
        show: async function (message: string, title = null, type?: string) {
            const messageType = type ? type.toLowerCase() : 'error'
            const messageTitle = title ? title : title === null ? (messageType === 'success' ? 'Success Response' : 'Error Response') : ''
            await dispatch({type: "set-visibility", payload: {key: 'notification', value: {status: message ? true : false, message, type: messageType, title: messageTitle}}})
        },
        hide: async function () {
            await dispatch({type: "set-visibility", payload: {key: 'notification', value: {status: false, message: state.notification.message, type: state.notification.type, title: state.notification.title}}})
        }
    }

    async function isConnected (value: boolean) {
        await dispatch({type: "set-visibility", payload: {key: 'isOnline', value }})
    }

    function setModal({key, value}: ISetModal) {
         dispatch({ type: "set-visibility", payload: { key, value } })
         dispatch({type: "set-visibility", payload: {key: 'isModal', value }})
    }

    const stateActions: IStateActions = {
        loader,
        notifier,
        isConnected,
        setModal,
    }

    return (
        <VisibilityContext.Provider value={{visibility: state, ...stateActions}} >
            {props.children}
        </VisibilityContext.Provider>
    )
}

export default VisibilityContext